const includesDate = (arr, date) => {
  return !!arr.find((elem) => {
    return elem.getTime() === date.getTime()
  })
}
const prevDate = (date, amount = 1) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount)
}

const nextDate = (date, amount = 1) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount)
}

const clearHoursOfTimestamp = (timestamp) => {
  const cloneDate = new Date(timestamp)
  cloneDate.setHours(0, 0, 0, 0)
  return cloneDate.getTime()
}

const clearHours = (date) => {
  const cloneDate = new Date(date)
  cloneDate.setHours(0, 0, 0, 0)
  return cloneDate
}

const stringToDate = (str) => {
  let tmp = str.replace(/-/g, '/')
  let date = new Date(Date.parse(tmp))
  return date
}

const formatDate = (date, format = 'yyyy-MM-dd') => {
  const args = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const i in args) {
    const n = args[i]
    if (new RegExp('(' + i + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? n : ('00' + n).substr(('' + n).length))
    }
  }
  return format
}

export {
  includesDate,
  prevDate,
  nextDate,
  clearHours,
  clearHoursOfTimestamp,
  stringToDate,
  formatDate
}
